<div class="cursor-pointer select-none hover:text-theme-primary-900 inline-flex gap-x-1.5">
  <svg *ngIf="currentSorting == thisSorting" [class.rotate-180]="inverseState" class="bi bi-caret-up place-self-center transition-all"
       height="16" viewBox="0 0 16 16"
       width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659"/>
  </svg>
  <span class="place-self-center">{{ displayName }}</span>
</div>
